export default {
  props: {
    terms: {
      type: String,
      default: '',
    },
    termsTranslationKey: {
      type: String,
      default: 'Form.agree',
    },
  },

  computed: {
    termsLink() {
      return this.privacyLink ? this.$t(this.termsTranslationKey, { privacyLink: this.privacyLink }) : '';
    },

    privacyLink() {
      return this.terms ? `<a target='_blank' href='${this.terms}'>${this.$t('Form.privacy')}</a>` : '';
    },
  },
};
